export const DEFAULT_UI_VIEW = "month";
export const DEFAULT_UI_STEP = "initial";
